type EditMilestoneError = {
  emptyName: boolean;
  duplicateName: boolean;
  endDateOutOfBound: boolean;
  notFound: boolean;
  listNotFound: boolean;
};

const editMilestoneError: EditMilestoneError = {
  emptyName: false,
  duplicateName: false,
  endDateOutOfBound: false,
  notFound: false,
  listNotFound: false,
};

export type { EditMilestoneError };

export { editMilestoneError };
